import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { ref, computed, watch } from 'vue'
import { cloneDeep, isEmpty } from 'lodash'
import { satelliteInfoAdd, satelliteInfoUpdate } from '@/api'
import { CODE_ENUM } from '@/common'
import moment from 'moment'
import { ElMessage } from 'element-plus'


export default /*#__PURE__*/_defineComponent({
  __name: 'satellite-form',
  props: ['visible', 'data'],
  emits: ['update:visible', 'on-success'],
  setup(__props, { emit: __emit }) {

const props = __props
const $emit = __emit

const mapRef = ref()
const formRef = ref()

const formData: any = ref({
  aliasName: '',
  satelliteCode: '',
  satelliteName: '',
  launchTime: undefined,
})

watch(
  () => props.visible,
  () => {
    if (props.visible) {
      if (!isEmpty(props.data)) {
        const { launchTime, aliasName, satelliteCode, satelliteName } =
          props.data
        console.log(new Date(launchTime), '==')
        formData.value = {
          launchTime: launchTime
            ? moment(launchTime).format('YYYY-MM-DD')
            : undefined,
          aliasName,
          satelliteCode,
          satelliteName,
        }
      }
    }
  }
)

const rules: any = {
  satelliteName: [{ required: true, message: '请输入' }],
  satelliteCode: [{ required: true, message: '请输入' }],
}

const submit = () => {
  formRef.value.validate((valid: boolean) => {
    if (valid) {
      handleAPI()
    }
  })
}

const loading = ref(false)
const handleAPI = async () => {
  loading.value = true
  const { launchTime } = formData.value
  const fn = props.data.id ? satelliteInfoUpdate : satelliteInfoAdd
  const res: any = await fn({
    ...formData.value,
    launchTime: launchTime ? moment(launchTime).valueOf() : undefined,
    id: props.data?.id,
  }).finally(() => {
    loading.value = false
  })
  if (res.code === CODE_ENUM.SUCCESS) {
    ElMessage.success(res?.msg)
    $emit('on-success')
    handleClose()
  }
}

const handleClose = () => {
  $emit('update:visible', false)
  formRef.value?.resetFields?.()
}

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createBlock(_component_el_dialog, {
    "model-value": props.visible,
    "destroy-on-close": "",
    title: props.data.id ? '编辑卫星' : '添加卫星',
    width: "480",
    "before-close": handleClose,
    "label-position": "left"
  }, {
    footer: _withCtx(() => [
      _createVNode(_component_el_button, { onClick: handleClose }, {
        default: _withCtx(() => [
          _createTextVNode(" 取消 ")
        ]),
        _: 1
      }),
      _createVNode(_component_el_button, {
        type: "primary",
        onClick: submit,
        loading: loading.value
      }, {
        default: _withCtx(() => [
          _createTextVNode(" 确定 ")
        ]),
        _: 1
      }, 8, ["loading"])
    ]),
    default: _withCtx(() => [
      _createVNode(_component_el_form, {
        ref_key: "formRef",
        ref: formRef,
        model: formData.value,
        rules: rules,
        class: "form ws_common_form",
        "label-width": 80
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_form_item, {
            label: "卫星名称",
            prop: "satelliteName"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_input, {
                modelValue: formData.value.satelliteName,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((formData.value.satelliteName) = $event)),
                clearable: "",
                maxlength: "50",
                placeholder: "请输入名称"
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, {
            label: "别称",
            prop: "aliasName"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_input, {
                modelValue: formData.value.aliasName,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((formData.value.aliasName) = $event)),
                clearable: "",
                maxlength: "50",
                placeholder: "请输入别称"
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, {
            label: "卫星ID",
            prop: "satelliteCode"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_input, {
                modelValue: formData.value.satelliteCode,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((formData.value.satelliteCode) = $event)),
                clearable: "",
                maxlength: "50",
                placeholder: "请输入卫星ID"
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, {
            label: "发射时间",
            prop: "launchTime"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_date_picker, {
                style: {"width":"100%"},
                modelValue: formData.value.launchTime,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((formData.value.launchTime) = $event)),
                type: "date",
                placeholder: "请选择日期",
                "value-format": "YYYY-MM-DD"
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["model"])
    ]),
    _: 1
  }, 8, ["model-value", "title"]))
}
}

})